import { FaqDetailsView } from '../views/FaqDetails/faqDetails.view';
import { FeatureFaqView } from '../views/FeatureFaq/featureFaq.view';
import { HelpView } from '../views/Help/help.view';
import { HelpSearchOrderView } from '../views/HelpSearchOrder/helpSearchOrder.view';
import { RouteType, type } from './Router';
import { Routes } from './types';

export const helpRoutes: RouteType[] = [
  {
    id: 'help-search-order',
    path: Routes.HelpSearchOrder,
    titleKey: 'pageTitles.searchOrder',
    type: type.SECURED,
    component: HelpSearchOrderView,
  },
  {
    id: 'help-faq',
    path: Routes.Faq,
    titleKey: 'pageTitles.faq',
    type: type.PUBLIC,
    component: FeatureFaqView,
  },
  {
    id: 'help-faq-details',
    path: Routes.FaqDetails,
    titleKey: 'pageTitles.faq',
    type: type.PUBLIC,
    component: FaqDetailsView,
  },
  {
    id: 'help',
    path: Routes.Help,
    titleKey: 'pageTitles.help',
    type: type.PUBLIC,
    component: HelpView,
  },
];
